/**
 * Implementation functions must return this symbol if they cannot
 * handle a particular argument type (so that another
 * implementation might). It is also available as
 * `this.NotApplicable` inside implementation functions.
 *
 * @type {Symbol}
 */
export const NotApplicable = Symbol('collections.NotApplicable');


/**
 * Returned by constructsUsing to specify which iterator is used
 * in an object's constructor generator.
 * @type {Object<Symbol>}
 */
export const constructUsing = {
  key: Symbol('constructUsing.key'),
  value: Symbol('constructUsing.value'),
  both: Symbol('constructUsing.both'),
};



// WEBPACK FOOTER //
// ./lib/rlink-collections/symbols.js